import React from 'react';
import { Card, CardContent, Typography, Box, Button, LinearProgress } from '@mui/material';
import { Target } from 'lucide-react';

const NextMilestoneCard = () => {
  const completed = 286;
  const total = 500;
  const remaining = total - completed;
  const progress = (completed / total) * 100;

  return (
    <Card className="next-milestone-card">
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          <Target size={24} style={{ color: 'var(--color-success)', marginRight: 8 }} />
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'var(--color-success)' }}>
            Next Milestone
          </Typography>
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          500 Completed Orders
        </Typography>
        <Box sx={{ my: 2 }}>
          <Box display="flex" justifyContent="space-between" mb={1}>
            <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
              {completed} / {total}
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.secondary' }}>
              {Math.round(progress)}%
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              height: 8,
              borderRadius: 4,
              backgroundColor: 'rgba(34, 197, 94, 0.15)',
              '& .MuiLinearProgress-bar': {
                backgroundColor: 'var(--color-success)',
                borderRadius: 4,
              },
            }}
          />
        </Box>
        <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
          {remaining} orders remaining to unlock
        </Typography>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
          Premium Branding Package
        </Typography>
        <Box sx={{
          width: '100%',
          height: 120,
          borderRadius: 'var(--radius-md)',
          background: 'linear-gradient(135deg, rgba(34, 197, 94, 0.1) 0%, rgba(34, 197, 94, 0.05) 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
          border: '1px solid var(--color-border)',
        }}>
          <Target size={48} style={{ color: 'var(--color-success)', opacity: 0.3 }} />
        </Box>
        <Button variant="contained" fullWidth sx={{ backgroundColor: 'var(--color-success)', '&:hover': { backgroundColor: 'var(--color-success-dark)' } }}>
          View Milestone
        </Button>
      </CardContent>
    </Card>
  );
};

export default NextMilestoneCard;